import React from "react";
import TitleBar from "../../Components/PagesComponents/Universal/TopLableBg";
import Hbar from "../../Components/PagesComponents/Universal/History-bar";
import {NavLink} from "react-router-dom";
import BodyfillersContent from "../../Components/PagesComponents/ProductUnique/BodyfillersContent";
import Bg from "../../img/bakcground/BgProduct.png";



const Bodyfiller = () => {

    return (
        <>
            <TitleBar kor={"바디필러"} eng={"Body Filler"} bgimg={Bg}/>
            <Hbar lvl1={"제품"} lvl2={"바디필러"}
                  nav1={<li><NavLink to="/Allproducts"> 전체 제품 </NavLink></li>}
                  nav2={<li><NavLink to="/Dermalfillers"> 안면필러 </NavLink></li>}
                  nav3={<li><NavLink to="/Bodyfiller"> 바디필러 </NavLink></li>}
                  nav4={<li><NavLink to="/Wounddressing"> 창상피복재</NavLink></li>}
                  nav5={<li><NavLink to="/Toxins">톡신</NavLink></li>}
            />
            <BodyfillersContent/>
        </>

    );
};

export default Bodyfiller;